module.exports = __webpack_public_path__ + "static/media/IngredientImagePlaceholder3.e3f04b84.png";